import React from "react";

function CheckboxComponent(props) {
  const { id, label, required, value, onChange } = props;
  const name = `${id}_checkbox_${Math.random(100000)}`;

  return (
    <React.Fragment>
      <div className="form-check">
        <label className="form-check-label">
          <input
            name={name}
            className="form-check-input"
            type="checkbox"
            required={required}
            defaultChecked={value}
            onChange={(e) => onChange(e.target.checked)} />
          {label}
        </label>
      </div>
    </React.Fragment>
  )
}

export default CheckboxComponent;